import {initAnnouncement} from "./modules/announcement.js";
import {initSiteHeader} from "./modules/site-header.js";
import {initProductList} from "./modules/product-list.js";
import {initParcelQuantity} from "./modules/parcel-service-quantity.js";
import {initProductVariant} from "./modules/product-variant.js";
import {initInfoAccordion} from "./modules/info-accordion.js";
import {initProductGallery} from "./modules/product-gallery.js";
import {initAddOns} from "./modules/add-on.js";
import {initGiftCardMessage} from "./modules/gift-card-message.js";
import {initAddOnPage} from "./modules/add-on-page.js";
import {initShoppingBag} from "./modules/shopping-bag.js";
import {initPasswordVisibility} from "./modules/password-visibility.js";
import {initAddressLookup} from "./modules/address-lookup.js";
import {initCalendar} from "./modules/calendar.js";
import {initCheckout} from "./modules/checkout.js";
import {initOccasionName} from "./modules/occasion-name.js";
import {initAddressForm} from "./modules/address-form.js";
import {initRecipients} from "./modules/recipients.js";
import {initAddressBook} from "./modules/address-book.js";
import {initCountrySelects} from "./modules/country-select.js";
import {initCorporateCarousel} from "./modules/corporate-carousel.js";
import {initAccountDetails} from "./modules/account-details.js";
import {initAccountBilling} from "./modules/account-details.js";
import {initAccountPreferences} from "./modules/account-preferences.js";
import {initScrollCarousels} from "./modules/scroll-carousel.js";
import {initVideoHero} from "./modules/video-hero.js";
import {initInfoDialogs} from "./modules/info-dialog.js";
import {initHtmxSetup} from "./modules/htmx-setup.js";

window.LadooComponents = {
  initAnnouncement,
  initSiteHeader,
  initProductList,
  initParcelQuantity,
  initProductVariant,
  initInfoAccordion,
  initProductGallery,
  initAddOns,
  initGiftCardMessage,
  initAddOnPage,
  initShoppingBag,
  initPasswordVisibility,
  initAddressLookup,
  initCalendar,
  initCheckout,
  initOccasionName,
  initAddressForm,
  initRecipients,
  initAddressBook,
  initCountrySelects,
  initCorporateCarousel,
  initAccountDetails,
  initAccountBilling,
  initAccountPreferences,
  initScrollCarousels,
  initVideoHero,
  initInfoDialogs,
  initHtmxSetup,
  init() {
    this.initHtmxSetup();
    this.initAnnouncement();
    this.initSiteHeader();
    this.initProductList();
    this.initParcelQuantity();
    this.initProductVariant();
    this.initInfoAccordion();
    this.initProductGallery();
    this.initAddOns();
    this.initGiftCardMessage();
    this.initAddOnPage();
    this.initShoppingBag();
    this.initPasswordVisibility();
    this.initCountrySelects();
    this.initAddressLookup();
    this.initCalendar();
    this.initCheckout();
    this.initOccasionName();
    this.initAddressForm();
    this.initRecipients();
    this.initAddressBook();
    this.initCorporateCarousel();
    this.initAccountDetails();
    this.initAccountBilling();
    this.initAccountPreferences();
    this.initScrollCarousels();
    this.initVideoHero();
    this.initInfoDialogs();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LadooComponents.init();
  console.log('✅ App initialised');
});